import React from 'react';
import { ToolComponentProps } from './types';
import { ChevronRight, ChevronDown } from 'lucide-react';

export const ShellExecTool: React.FC<ToolComponentProps> = ({
  input,
  output,
  isError,
  isExpanded,
  onToggle,
  isStreaming
}) => {
  const command = input?.command || '';
  const timeout = input?.timeout || 5; // Default timeout is 5 seconds
  const hasOutput = output !== undefined && output !== null;

  return (
    <div>
      <div
        className={`flex items-center gap-1 ${hasOutput ? 'cursor-pointer hover:bg-accent/30' : ''} rounded transition-colors`}
        onClick={hasOutput ? onToggle : undefined}
      >
        <span className="flex-1">
          <span className="text-muted-foreground">$ ({timeout}s)</span> {command}
          {isStreaming && (
            <span className="text-muted-foreground ml-2 text-xs animate-pulse">running...</span>
          )}
        </span>
        <span className="text-muted-foreground inline-block w-3">
          {hasOutput && (isExpanded ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />)}
        </span>
      </div>

      {isExpanded && hasOutput && (
        <div className={`mt-2 rounded ${isError ? 'bg-destructive/10 text-destructive' : 'bg-muted'} overflow-x-auto`}>
          <pre className="whitespace-pre">
            {typeof output === 'string' ? (output || '(no output)') : JSON.stringify(output, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};